import { __awaiter } from '../../_virtual/_tslib.js';
import { mirrorPluginsIns } from './handlePlugin.js';
import { SIGNMANAGE, EVENTTYPES } from '../utils/enum.js';
import { getGlobalSupport, getTimestamp, on, _global } from '../utils/unils.js';
import { options } from './option.js';
import { _techReportPb } from './new-report.js';
import { isInBrowser } from '../utils/isInBrowser.js';

const _support = getGlobalSupport();
/**
 * 用户行为日志记录管理模块
 *  20条堆栈,存在error的情况 上报并且清空
 */
class Breadcrumb {
    constructor() {
        this.maxBreadcrumbs = 10;
        this.stack = [];
        this.isSet = false;
    }
    push(data) {
        return __awaiter(this, void 0, void 0, function* () {
            if ((options === null || options === void 0 ? void 0 : options.config['user-log-deep']) && !this.isSet) {
                this.maxBreadcrumbs = options === null || options === void 0 ? void 0 : options.config['user-log-deep'];
                this.isSet = true;
            }
            // plugin-before
            const breadcRumbRes = yield mirrorPluginsIns.before(EVENTTYPES.BREABCRUMB, data);
            if (!breadcRumbRes)
                return;
            this.immediatePush(data);
            // 销毁上报
            on(_global, 'beforeunload', () => {
                const isError = this.stack.filter(item => item.status === 'error');
                if (isError.length) {
                    this.goToReport(this.stack);
                    window.__biliMirrorPbInstance__ &&
                        window.__biliMirrorPbInstance__.flush &&
                        window.__biliMirrorPbInstance__.flush();
                }
            });
        });
    }
    immediatePush(data) {
        data.time || (data.time = getTimestamp());
        if (this.stack.length >= this.maxBreadcrumbs) {
            const isError = this.stack.filter(item => item.status === 'error');
            if (isError.length) {
                // 存在错误的日志,循环上报后,清空堆栈
                this.goToReport(this.stack);
                this.clear();
            }
            else {
                // 没有存在错误的行为日志,清空堆栈
                this.clear();
            }
        }
        this.stack.push(data);
        this.stack.sort((a, b) => a.time - b.time);
    }
    shift() {
        return this.stack.shift() !== undefined;
    }
    clear() {
        this.stack = [];
    }
    getStack() {
        return this.stack;
    }
    goToReport(dataList) {
        let userLogExtra = {};
        dataList.forEach((item, index) => {
            userLogExtra[`logStep-${index}`] = item;
        });
        _techReportPb({
            type: 'custom',
            event: `${options.origin}.${options.module}.USERLOG`,
            msg: Object.assign({ userLogInfo: Object.assign({}, userLogExtra) }, SIGNMANAGE.TECH_CUSTOM)
        });
        // plugin-after
        mirrorPluginsIns.after(EVENTTYPES.BREABCRUMB, this.stack);
        this.clear();
    }
}
const breadcrumb = isInBrowser() ? _support.breadcrumb || (_support.breadcrumb = new Breadcrumb()) : null;

export { breadcrumb };
